import { Theme } from '@yandex-int/k-common/typings';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import qs from 'query-string';
import React, { useCallback } from 'react';

import { SEARCH_PARAM_PROMO_THEME_SCROLL } from 'common.components/constants';
import { MetrikaParams } from 'common.components/hooks/use-prep-lesson-click';

import PromoTheme from '../__theme/promo__theme';

import './promo__themes.scss';

interface OwnProps {
    themes: Array<Theme>;
    metrikaParams: MetrikaParams;
}

interface Props extends OwnProps, WithRouterPathHOC {}

const PromoThemes = ({ themes, metrikaParams, location }: Props) => {
    const promoThemeId = Number(qs.parse(location.search)[SEARCH_PARAM_PROMO_THEME_SCROLL]);

    const scrollToTheme = useCallback((themeRef: React.RefObject<HTMLDivElement>) => {
        if (!isSSR) {
            const scrollTop = Math.abs(themeRef.current?.getBoundingClientRect().top!);

            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }, []);

    return (
        <div className="promo__themes">
            {themes.map((theme: Theme, index: number) => {
                const themeMetrikaParams = {
                    ...metrikaParams,
                    // нумерация - с единицы, первый блок - ГЗшки, лежащие в теме верхнего уровня
                    section_block_number: index + 2,
                    section_block_name: theme.name,
                };
                return (
                    <PromoTheme
                        metrikaParams={themeMetrikaParams}
                        promoThemeId={promoThemeId}
                        scrollToTheme={scrollToTheme}
                        theme={theme}
                    />
                );
            })}
        </div>
    );
};

export default withRouterPath(PromoThemes);
